import React, { useContext, useEffect, useState } from 'react';
import { Grid, Row } from "react-bootstrap";
import {Card} from 'components/Card/Card.jsx';
import BeatLoader from "react-spinners/BeatLoader";
import Cookies from 'universal-cookie';
import cookieManagement from '../utilities/Cookie' ;
import { DeleteOutlined } from '@ant-design/icons';
import { FetchAPI } from 'api/fetch';
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { PostAPI } from "api/post.js";
import { Upload,Button } from 'antd'
import 'antd/dist/antd.css';
import { UploadOutlined } from '@ant-design/icons';
import { MDBCol } from 'mdbreact';
import InputField from '../components/UI/Input/InputField';
import swal from 'sweetalert';
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useTranslation } from 'react-i18next';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search, ColumnToggle, CSVExport } from 'react-bootstrap-table2-toolkit';
const cookies = new Cookies();
let logoName = cookies.get('clientSubDomain') == undefined ? cookieManagement.setClientSubDomainToCookie() : cookies.get('clientSubDomain');

const Wallet = props => {
  const { t, i18n } = useTranslation();
let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
let [walletVal, setWalletVal] = useState({});
let data = new FormData();
let [response, setResponse] = useState()
let [isDisabled, setIsDisabled] = useState(false)
let [loadSForm, setloadSForm] = useState(false);
let [pageLayoutData, setPageLayoutData] = useState('undefined');
let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
let [ModalformValues, setModalformValues] = useState();
let [error, setError] = useState(false);
const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
const language = currentLanguageCode === 'en' ? 'english' : 'chinese'
let [errorMsg, setErrorMsg] = useState();
let [productsData, setproductsData] = useState([]);
let [columns, setColumns] = useState([
    {
      dataField: "serial_no",
      text: "Serial No."
    },
    {
      dataField: "role_name",
      text: "Role Name"
    },
    {
      dataField: "customer_name",
      text: "Customer Name"
    }
  ]);

  const formElementsArray = [];
    for (let key in ModalformValues){
      formElementsArray.push({
        id: key,
        config: ModalformValues[key]
      });
    }


    useEffect(() => {
        (async () => {
            if (pageLayoutData != 'undefined') {
                let getUrl;
                setModalformValues(pageLayoutData[0].importButtonItems?.formValues)
                if(pageLayoutData[0].hasOwnProperty('apiEndPoint')){
                getUrl = pageLayoutData[0].apiEndPoint + '?customer_id=' + cookies.get('customer_id') + '&user_id=' + cookies.get('user_id') + '&language=' + language;
                const walletDataValues = await FetchAPI(getUrl);
                const walletDataValuesJson =  await walletDataValues.json();
               
                if(walletDataValues.status == 200){
                    setWalletVal(walletDataValuesJson.data); 
                    setColumns(walletDataValuesJson.data.columns);
                    setproductsData(walletDataValuesJson.data.data);
                }
                else{
                    swal('Something went wrong','Please try again','error')
                  }
            }
        }
        })()
        
    }, [pageLayoutData, response]);
    
    useEffect(() => {
        if (globalLoadIndicator == '2') {
          setPageLayoutData(pageLayoutDataContext);
        } else if (globalLoadIndicator == '1') {
            setPageLayoutData('undefined');
        }
      }, [globalLoadIndicator]);
    

    let walletStatement = null;
    let showDataTable = true;

    let centeredDiv = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '30vh'
    }

    const WalletCards = ({logoName, walletData}) => {
        let rowLengthClass = "col-md-6";
        let sendRowCardsClass = 'col-md-4';
        let showThirdCard = false
        let contentStyle = {
            position: 'relative',
            overflow: 'hidden',
            fontSize: '45px'
        };
        let countStyle = {fontSize: '22px' }
        // ROW 1 
        let card1 = {
            stats: `Total PO's: `+walletData.totalPo,
            icon: "fa fa-qrcode",
            count: walletData.totalQty
        }

        let card2 = {
            stats: 'IOT\'s Generated',
            icon: "fa fa-bookmark",
            count: walletData.totalGenerated
        }

        let card3 = {} //Not available for icapidilite
        // ROW 2
        let card4 = {
            stats: 'Balance Count',
            icon: "fa fa-bookmark-o",
            count: walletData.balanceCount
        }
        let card5 = {
            stats: 'Drawn Count',
            icon: "fa fa-download",
            count: walletData.drawnCount
        }
        let card6 = {
            stats: 'Free Count',
            icon: "fa fa-download",
            count: walletData.freeCount
        }
        // ROW 3
        let card7 = {
            stats: 'Balance Count',
            icon: "fa fa-bar-chart-o",
            count: walletData.totalUsed
        }
        let card8 = {
            stats: 'Products',
            icon: "fa-solid fa-gift",
            count: walletData.products
        }
        let card9 = {
            stats: 'Cartons',
            icon: "fa fa-cube",
            count: walletData.cartons
        }
        let card10 = {
            stats: 'TP',
            icon: "fa fa-truck",
            count: walletData.tps
        }
        let card11 = {}

        if(cookies.get("customer_id") == '12'){
            showDataTable = false;
            rowLengthClass = "col-md-4";
            sendRowCardsClass = 'col-md-3';
            showThirdCard = true
            card1 ={
                stats:`${t("wallet_statement.total_pos")}: ` +walletData.TotalPO,
                icon: "fa fa-qrcode",
                count: walletData.TotalPO
            }
             card2 = {
                stats: `${t("wallet_statement.iot_generated")}`,
                icon: "fa fa-bookmark",
                count: walletData.TotalGenerated
            }
            card3 = {
                stats: `${t("wallet_statement.total_assigned")}`,
                icon: "fa fa-check-square-o",
                count: walletData.ToatalAssigned
            }
           card4 = {
                stats: `${t("wallet_statement.plant_assigned")}`,
                icon: "fa fa-building",
                count: walletData.plantAssigned
            }
           card5 = {
                stats: `${t("wallet_statement.d2c_assigned")}`,
                icon: "fa fa-tasks",
                count: walletData.D2CAssigned
            }
           card6 = {
                stats: `${t("wallet_statement.available_count")}`,
                icon: "fa fa-braille",
                count: walletData.Availablecount
            }
           card7 = {
                stats: `${t("wallet_statement.total_used")}`,
                icon: "fa fa-database",
                count: walletData.Totalused
            }
           card8 = {
                stats: `${t("wallet_statement.gift_box")}`,
                icon: "fa fa-gift",
                count: walletData.Giftbox
            }
           card9 = {
                stats: `${t("wallet_statement.shipper_carton")}`,
                icon: "fa fa-cube",
                count: walletData.ShipperCarton
            }
           card10 = {
                stats: `${t("wallet_statement.tp")}`,
                icon: "fa fa-truck",
                count: walletData.TP
            }
            card11 = {
                stats: `${t("wallet_statement.drawn_count")}:`,
                icon: "fa fa-line-chart",
                count: walletData.Downloaded
            }
        }

        function buildCard(cardDetails){
            return <Card
            stats= {cardDetails.stats}
            statsIcon={cardDetails.icon}
            content={
                <div style={contentStyle} >
                    <div className="col-md-4">
                        <i className={cardDetails.icon}></i>
                    </div>
                    <div className="col-md-8">
                        <span style={countStyle}>{ cardDetails.count }</span>
                    </div>
                </div>
            }
        />
        }

        return (
            <Grid fluid>
                <Row>
                <Card style={{ fontSize: '12px' }}
                    title= {`${t("wallet_statement.title1")}`}
                    title2= {`${t("wallet_statement.title2")}`}
                    content={
                        <div>
                        <div className="row">
                            <div className={rowLengthClass}>
                            {buildCard(card1)}
                            </div>
                            <div className={rowLengthClass}>
                            {buildCard(card2)}
                            </div>
                           {showThirdCard && <div className={rowLengthClass}>
                           {buildCard(card3)}
                            </div>}
                        </div>

                        <div className="row">
                            <div className={sendRowCardsClass}>
                            {buildCard(card4)}
                            </div>
                            <div className={sendRowCardsClass}>
                            {buildCard(card5)}
                            </div>
                            <div className={sendRowCardsClass}>
                            {buildCard(card6)}
                            </div>
                            {showThirdCard &&<div className={sendRowCardsClass}>
                            {buildCard(card11)}
                            </div>}
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                            {buildCard(card7)}
                            </div>
                            <div className="col-md-3">
                            {buildCard(card8)}
                            </div>
                            <div className="col-md-3">
                            {buildCard(card9)}
                            </div>
                            <div className="col-md-3">
                            {buildCard(card10)}
                            </div>
                        </div>
                        </div>
                    }
                >
                </Card>
                </Row>
            </Grid>
        );
    };

    const UploadFileCard = () => {
        showDataTable = false
        const allowedfileExtensions = ["xlsx"]

        const dummyRequest = async ({ file, onSuccess }) => {
            setTimeout(() => {
                onSuccess("ok");
            }, 0);
        }
        
        function removeFile(){
            const keys = [];
            for (const key of data.keys()) {
                keys.push(key);
            }
            for (const idx in keys) {
                data.delete(keys[idx]);
            }
        }

        const uploadProps = {
            name: 'file',
            listType: 'text',
            maxCount: 1,
            customRequest: dummyRequest,
            beforeUpload: (file) => {
                var span = document.createElement("span");
                span.innerHTML = `The specified file <code>${file.name}</code> could not be uploaded`;
                let fileExtension = file.name.match(/\.([^\.]+)$/);
                if (file.name.match(/\.([^\.]+)$/) !== null && allowedfileExtensions.includes(fileExtension[1])) {
                    data.append("file", file)
                    return true;
                } else  {
                    swal({
                        title: 'Only files with the following extensions are allowed: xlsx',
                        content: span,
                        icon: "warning",
                    });
                    return Upload.LIST_IGNORE
                }
            },
            showUploadList: {
                showRemoveIcon: true,
                removeIcon: <DeleteOutlined style={{ color: '#FF0000' }} onClick={() => removeFile} />
            }
        }

        async function submitFile(e) {
            let Url = pageLayoutData[0].importButtonItems.saveApiEndPoint
            if (data.has("file")) {
                data.append('customer_id', cookies.get('customer_id'));
                data.append('user_id', cookies.get('user_id'));
                data.append('language', localStorage.getItem('i18nextLng') === 'en' ? 'english' : 'chinese')
                setloadSForm(true)
                setIsDisabled(true)
                response = await PostAPI(Url, data)
                if (response.data.data?.status === 409 && typeof response.data.data.message === 'string') {
                    setloadSForm(false)
                    setIsDisabled(false)
                    swal(response.data.data.message, {
                        icon: "error",
                        button: `${t("alerts.ok")}`
                    });
                    removeFile()
                }
                else if (response.data.data?.status === 409) {
                    setloadSForm(false)
                    setIsDisabled(false)
                    if(Array.isArray(response.data.data?.message)){
                    let msg, msg1;
                    if (response.data.data.message.length > 1) {
                        msg = response.data.data.message.toString();
                        msg1 = msg.split(",Import").join("\nImport")
                    } else{
                        msg1 = response.data.data.message[0]
                    }
                    swal(msg1, {
                        icon: "error",
                        text: msg1,
                        button: `${t("alerts.ok")}`
                    });
                }
                    removeFile()
                }
                else if(response.data?.data) {
                    setloadSForm(false)
                    setIsDisabled(false)
                    swal(response.data.data.message, {
                        icon: "success",
                        timer: 2000,
                        button: false
                    });
                setResponse(response.data)
                }
                else {
                    setloadSForm(false)
                    setIsDisabled(false)
                    swal(`${t("alerts.something_went_wrong")}`, {
                        icon: "error",
                        timer: 2000,
                        button: false
                        });
                }
                removeFile()
            }
            else {
                swal({ title: `${t("alerts.upload_file")}`, text: `${t("alerts.upload_file_mandotory")}`, icon: "warning", button: `${t("alerts.ok")}` })
            }
        }

        function cardDetails(formElementsArray) {
            return <Card
                filter={true}
                content={
                    <div style={{ width: "35em" }}>
                        {formElementsArray.map(formElement => (
                            (formElement.config.elementType !== "maps" && formElement.config.elementType !== "textareaMoreHeight") ?
                                <MDBCol md="6" className="mb-6"
                                    key={formElement.id}>
                                    <InputField
                                        key={formElement.id}
                                        customFile={true}
                                        elementType={formElement.config.elementType}
                                        elementConfig={formElement.config.elementConfig}
                                        value={(formElement.config.value == null) ? '' : formElement.config.value}
                                        labelName={formElement.config.label}
                                        id={formElement.config.id}
                                        isValidate={formElement.config.validate}
                                    />
                                    {(formElement.config.elementType === 'file') ?
                                        <span>
                                            <Upload  {...uploadProps}>
                                                <Button icon={<UploadOutlined />}>Click to Upload</Button>
                                            </Upload>
                                        </span> : ""}
                                </MDBCol> : ''
                        ))}
                    </div>
                }
                legend={
                    <div className='text-center mb-3 row'>
                        <button
                         disabled = {isDisabled}
                            onClick={() => submitFile(ModalformValues)}
                            class="btn btn-outline-primary btn-rounded waves-effect"
                            style={{ borderRadius: '15px', float: 'right', marginLeft: '46em', marginTop: "3em", fontSize: 'xx-small' }}
                        >Submit</button>
                    </div>
                }
            />
        }

        return (
            <Grid fluid>
                <Row>
                    <Card style={{ fontSize: '12px' }}
                        title={(pageLayoutData[1]) ? t(pageLayoutData[1].title1) : ''}
                        title2={(pageLayoutData[1]) ? t(pageLayoutData[1].title2) : ''}
                        content={
                            <div>
                                <div style={centeredDiv}>
                                    {cardDetails(formElementsArray)}
                                </div>
                            </div>
                        }
                    >
                    </Card>
                </Row>
            </Grid>
        );

    };

    return(
        (pageLayoutData != 'undefined') ?
        <div className="content">
            {pageLayoutDataContext.length>1 ? <UploadFileCard/> : 
                <WalletCards
                    logoName={logoName}
                    walletData={walletVal}
                />}
             <div>
            {/* {loadTableData ? */}
              <ToolkitProvider
                keyField="id1"
                data={productsData}
                columns={columns}
              >
              {props => (
               showDataTable ?
                <BootstrapTable
                  { ...props.baseProps }
                  striped
                  hover
                  condensed
                  bordered={ false }
                  pagination={productsData.length > 10 ? paginationFactory() : ''}
                  noDataIndication="Table is Empty"
                />:""
              )}
              </ToolkitProvider>
          </div>
          {(loadSForm) &&
              <div className='beatLoader-centered'>
                  <div className='spanLoading'>
                      <span>Loading...</span>
                  </div>
                  <BeatLoader />
              </div>
              }
        </div>

        : <div className="content">
        <Grid fluid>
          <div className="text-center" style={{ margin: "200px" }}><BeatLoader size={15} margin={3} color={"#3C423C"} /></div>
        </Grid>
      </div>
    );
}

export default Wallet;